var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrequalCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#2566B0",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#2566B0",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_717_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5933 23.4C23.4067 23.0067 22.8333 22.76 22.8333 22.1333C22.8333 21.4533 23.5733 21.2067 24.04 21.2067C24.9133 21.2067 25.2333 21.8667 25.3067 22.1L26.36 21.6533C26.26 21.3533 25.8133 20.3733 24.6667 20.16V19.3333H23.3333V20.1733C21.68 20.5467 21.6733 22.08 21.6733 22.1467C21.6733 23.66 23.1733 24.0867 23.9067 24.3533C24.96 24.7267 25.4267 25.0667 25.4267 25.7067C25.4267 26.46 24.7267 26.78 24.1067 26.78C22.8933 26.78 22.5467 25.5333 22.5067 25.3867L21.4 25.8333C21.82 27.2933 22.92 27.6867 23.3333 27.8067V28.6667H24.6667V27.84C24.9333 27.78 26.6 27.4467 26.6 25.6933C26.6 24.7667 26.1933 23.9533 24.5933 23.4ZM18 30H16.6667V26H20.6667V27.3333H19.0133C20.0867 28.94 21.92 30 24 30C27.3133 30 30 27.3133 30 24H31.3333C31.3333 28.0533 28.0533 31.3333 24 31.3333C21.52 31.3333 19.3267 30.1 18 28.22V30ZM16.6667 24C16.6667 19.9467 19.9467 16.6667 24 16.6667C26.48 16.6667 28.6733 17.9 30 19.78V18H31.3333V22H27.3333V20.6667H28.9867C27.9133 19.06 26.08 18 24 18C20.6867 18 18 20.6867 18 24H16.6667Z",
    fill: "#2566B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_717_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrequalCurrency);
export default __webpack_public_path__ + "static/media/prequal_currency.a4fe27fb.svg";
export { ForwardRef as ReactComponent };